import { REMOVE_STATIC_INDICATION } from './actionTypes';

const removeStaticIndication = staticIndication => ({ type: REMOVE_STATIC_INDICATION, payload: staticIndication });

export default removeStaticIndication;
